import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./SnackBar.css";

/**
 * Snackbar component (modern style like success alert)
 * @param {string} title - عنوان پیام
 * @param {string} description - توضیحات پیام
 * @param {"success"|"error"|"info"} type - نوع پیام برای رنگ‌بندی
 * @param {number} duration - مدت نمایش (میلی‌ثانیه)
 * @param {function} onClose - تابعی که بعد از بسته شدن فراخوانی می‌شود
 */
export default function Snackbar({
  title,
  description,
  type,
  duration,
  onClose,
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (title) {
      setVisible(true);
      const timeout = setTimeout(() => {
        setVisible(false);
        setTimeout(() => onClose && onClose(), 300);
      }, duration);
      return () => clearTimeout(timeout);
    }
  }, [title, duration, onClose]);

  if (!title) return null;

  return (
    <div className={`snackbar ${type} ${visible ? "show" : "hide"}`}>
      <div className="snackbar-content">
        <div className="snackbar-left">
          <div className="snackbar-icon">
            {type === "success" && (
              <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                   viewBox="0 0 24 24" strokeWidth="1.5"
                   stroke="currentColor" className="icon">
                <path strokeLinecap="round" strokeLinejoin="round"
                      d="m4.5 12.75 6 6 9-13.5" />
              </svg>
            )}
            {type === "error" && (
              <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                   viewBox="0 0 24 24" strokeWidth="1.5"
                   stroke="currentColor" className="icon">
                <path strokeLinecap="round" strokeLinejoin="round"
                      d="M6 18 18 6M6 6l12 12" />
              </svg>
            )}
            {type === "info" && (
              <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                   viewBox="0 0 24 24" strokeWidth="1.5"
                   stroke="currentColor" className="icon">
                <path strokeLinecap="round" strokeLinejoin="round"
                      d="M11.25 11.25v5.25m0-8.25h.008v.008H11.25V8.25z" />
              </svg>
            )}
          </div>
          <div>
            <p className="snackbar-title">{title}</p>
            <p className="snackbar-desc">{description}</p>
          </div>
        </div>
        <button className="snackbar-close" onClick={() => setVisible(false)}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none"
               viewBox="0 0 24 24" strokeWidth="1.5"
               stroke="currentColor" className="icon">
            <path strokeLinecap="round" strokeLinejoin="round"
                  d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
}

Snackbar.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.oneOf(["success", "error", "info"]),
  duration: PropTypes.number,
  onClose: PropTypes.func,
};

Snackbar.defaultProps = {
  type: "success",
  duration: 3000,
  onClose: () => {},
};
